import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import UsersList from "../../Modals/usersList";
import { Box, Tabs, Tab } from "@mui/material";
import {
  useGetPromotionByIdQuery,
  useGetPromotionReactionsByIdQuery,
} from "../../services/promotions";
import PromotionFeedbackTable from "../../features/manageFeedbackReports/feedbackTable";
import usePermission from "../../hooks/userAccess";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const ViewPromotion = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const { isView } = usePermission({
    label: "Online Brands Management",
    page_permission: "isView",
  });

  const { data: promoRes } = useGetPromotionByIdQuery(
    id ? { id } : ({ id: "" } as any),
    { skip: !id }
  );
  // const { data: promoReactionsRes } = useGetPromotionReactionsByIdQuery(id ? { id } : ({ id: '' } as any), { skip: !id });

  const promo = (promoRes as any)?.data || null;
  const [openUserModal, setOpenUserModal] = React.useState(false);
  const [selectedUserIds, setSelectedUserIds] = React.useState<string[]>([]);
  const usersList = ((promo?.users || []) as string[]).map((uid: string) => ({
    id: uid,
    label: uid,
    avatar: "/static/images/user_placeholder.png",
  }));
  const handleOpenAudience = () => {
    setSelectedUserIds(usersList.map((u) => u.id));
    setOpenUserModal(true);
  };
  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  return (
    <>
      <div className="main_title">
        <h1>Promotion Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate(-1)}>Online Brands Management</button>{" "}
          - Promotion Detail
        </p>
      </div>

      {isView && (
        <div className="table_header">
          <div className="left_s">
            <Box className="custom_tabs1" sx={{ width: "100%" }}>
              <Tabs
                value={valueTabs}
                onChange={handleChangeTabs}
                aria-label="basic tabs example"
                className="custom_tabs_links"
              >
                <Tab label="Promotion Detail" {...a11yProps(0)} />
                <Tab label="Feedback & Rating" {...a11yProps(1)} />
              </Tabs>
            </Box>
          </div>
        </div>
      )}

      {isView && (
        <div className="cards view_page">
          <CustomTabPanel value={valueTabs} index={0}>
            {/* promotion Info */}

            <div className="section_title">
              <h2>Promotion Info</h2>
            </div>
            <div className="gap_p">
              <div className="vew_img v2 no_radius w_100">
                <h6>Image</h6>
                <figure>
                  <img
                    src={promo?.image || "/static/images/placeholder.png"}
                    alt="img"
                  />
                </figure>
              </div>
              <div className="w_33">
                <h6>Title</h6>
                <p>{promo?.title || "-"}</p>
              </div>
              <div className="w_33">
                <h6>Type</h6>
                <p>
                  {promo?.type === 1
                    ? "App only"
                    : promo?.type === 2
                    ? "In-store"
                    : "-"}
                </p>
              </div>
              <div className="w_33">
                <h6>Date Registered</h6>
                <p>
                  {promo?.createdAt
                    ? new Date(promo.createdAt).toLocaleDateString()
                    : "-"}
                </p>
              </div>
              <div className="w_33">
                <h6>Schedule</h6>
                <p>
                  {promo?.startFrom
                    ? new Date(promo.startFrom).toLocaleDateString()
                    : "-"}{" "}
                  to{" "}
                  {promo?.expireAt
                    ? new Date(promo.expireAt).toLocaleDateString()
                    : "-"}
                </p>
              </div>
              <div className="w_33">
                <h6>Target Audience</h6>
                <p>
                  <button className="anchor_link" onClick={handleOpenAudience}>
                    {usersList.length
                      ? `${usersList.length} Users`
                      : "No Users"}
                  </button>
                </p>
              </div>
              <div className="w_33">
                <h6>URL (for external articles)</h6>
                <p>{promo?.url || "-"}</p>
              </div>
              <div className="w_100">
                <h6>Description</h6>
                <p
                  dangerouslySetInnerHTML={{
                    __html: promo?.description || "-",
                  }}
                ></p>
              </div>
            </div>
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs} index={1}>
            <PromotionFeedbackTable showPromotionColumn={false} />
          </CustomTabPanel>
        </div>
      )}
      <UsersList
        open={openUserModal}
        onClose={() => setOpenUserModal(false)}
        setOpen={setOpenUserModal}
        userIds={selectedUserIds}
        usersList={usersList}
      />
    </>
  );
};

export default ViewPromotion;
